import { ChangeDetectionStrategy, Component, computed, inject, input } from "@angular/core";

import { InputSelectOption } from "@components/shared/inputs/input-select/input-select.model";
import { EudrDds } from "@shared/interfaces/eudr-dds.interface";
import { LocalizationUtils } from "@shared/utils";

import { EudrDdsPageService } from "../eudr-dds-page.service";

@Component({
  selector: "app-dds-status-tag",
  templateUrl: "./dds-status-tag.component.html",
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DdsStatusTagComponent {
  private readonly eudrDdsPageService: EudrDdsPageService = inject(EudrDdsPageService);

  readonly status = input.required<EudrDds.StatusEnum>();

  readonly lastStatusUpdate = input.required<string>();

  readonly isDdsStatusUpdateFailed = input.required<boolean>();

  readonly shouldShowAlertIcon = input.required<boolean>();

  readonly translations = {
    statusErrorTooltipContent: $localize`:@@shared.statuserror.explanation:The latest status could not be retrieved from TRACES due to technical issues or absence of TRACES credentials.`,
    statusRetrievedDate: $localize`:@@shared.statuserror.date:The current status has been last retrieved on`,
  };

  private readonly statusDisplayText = computed(() => LocalizationUtils.getStatus(this.status()));

  readonly statusTagClass = computed(() =>
    this.eudrDdsPageService.getStatusTagColor(this.status()),
  );

  readonly tag = computed<InputSelectOption>(() => ({
    label: this.statusDisplayText(),
    svgIcon: this.isDdsStatusUpdateFailed() && this.shouldShowAlertIcon() ? "alert-triangle" : null,
    iconClass: this.isDdsStatusUpdateFailed() && this.shouldShowAlertIcon() ? "warn-icon" : null,
  }));
}
